import request from '@/utils/request'
import type { AxiosResponse } from 'axios'

/** The top bar's space context as the backend keeps it (#238): "all", a space id, or null (never chosen). */
export interface SpaceContextDto {
  current_id: string | null
  recent: string[]
}

/** GET /api/v2/me/space-context — the caller's stored space context. */
export function getSpaceContext(): Promise<AxiosResponse<{ data: SpaceContextDto }>> {
  return request({ url: '/api/v2/me/space-context', method: 'get' })
}

/** PUT /api/v2/me/space-context — stores it; answers with what was stored. */
export function updateSpaceContext(data: SpaceContextDto): Promise<AxiosResponse<{ data: SpaceContextDto }>> {
  return request({ url: '/api/v2/me/space-context', method: 'put', data })
}
